export { ReactComponent as ArrowToLeft } from './assets/icons/arrow_to_left.svg';
export { ReactComponent as ArrowToRight } from './assets/icons/arrow_to_right.svg';
export { ReactComponent as Icon } from './assets/icons/icon.svg';
export { ReactComponent as MestrIcon } from './assets/images/logo_light.svg';
